module.exports = __webpack_public_path__ + "assets/img/logo2.9e94c27e.png";